import { api } from '@api'
import { useQuery } from '@tanstack/react-query'
import { ScheduledMessage } from './usePaginateScheduledMessages'

interface GetScheduledMessageByIdResponse {
  scheduledMessage: ScheduledMessage
}

const fetchScheduledMessageById = async (id: string): Promise<ScheduledMessage> => {
  const { data } = await api.get<GetScheduledMessageByIdResponse>(`/scheduled-messages/${id}`)
  return data.scheduledMessage
}

export const useGetScheduledMessageById = (id: string) => {
  return useQuery<ScheduledMessage>({
    queryKey: ['scheduled-message', id],
    queryFn: () => fetchScheduledMessageById(id),
    enabled: !!id,
  })
}

